import restGql from 'graphql-tag';

export const ProductsQuery = restGql`#graphql
    query Products($siteId: String!, $validOn: String!, $includeDiscontinued: Boolean!, $includeHiddenByUser: Boolean!) {
        result(siteId: $siteId, validOn: $validOn, includeDiscontinued: $includeDiscontinued, includeHiddenByUser: $includeHiddenByUser)@rest(type: "ProductsResult", path: "/v2/products?institutionId={args.siteId}&includeDiscontinued={args.includeDiscontinued}&includeHiddenByUser={args.includeHiddenByUser}&validOn={args.validOn}") {
            products {
                id
                title
                pricing
                discountable
                hiddenByUser
            }
        }
    }
`;
